import { Action } from '../../framework/framework/components/Types';

import * as style from './style.css';
import React = require('react');

interface IProps{
    onClick?: Action;
    fontSize?: string;
}
interface IState{}

export default class BaseIcon extends React.Component<IProps, IState> {
    render() {
        const action = this.props.onClick ? () => this.props.onClick() : null;
        const styled = action == null ? {} : { cursor: 'pointer' };
        return < div className={style.iconWrapper} style={styled} onClick={action}>
            {this.renderIcon()}
        </div>;
    }

    protected renderIcon() :React.ReactNode {
        throw new Error('Method not implemented.');
    }
}
